<template>
  <tr v-if="JSON.stringify(data) === '[]'">
    <td colspan="20">
      <center>
        <div style="margin: 40px 0;width: 120px;">
          <img style="width: 120px;height: auto;" src="../../img/svg/dataNull.svg" />
          <span style="margin-top:10px;display: block;">暂无数据</span>
        </div>
      </center>
    </td>
  </tr>
</template>
<script>
export default {
  name: "noRecord",
  props: {
    data: { default: "" }
  },
  data() {
    return {
    };
  },
  methods: {},
  created: function() {}
};
</script>
<style scoped>
  @keyframes anim {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.loadingBox {
  width: 80px;
  height: 80px;
  padding: 0px;
}
.outerBox {
  left: calc(10% - 3px);
  top: calc(10% - 3px);
  width: 80%;
  height: 80%;
  position: absolute;
  border-radius: 50%;
  border: medium #409eff solid;
  border-right-color: transparent;
  animation: anim 847ms cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite;
}
.innerBox {
  left: calc(20% - 3px);
  top: calc(20% - 3px);
  width: 60%;
  height: 60%;
  position: absolute;
  border-radius: 50%;
  border: 3px #409eff solid;
  border-top-color: transparent;
  animation: anim 971ms cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/html/noData.vue